import type { MouseEvent } from 'react';

/** Filenames in public/templates/ — click downloads a local copy (no GDIISS access). */
export const TEMPLATE_FILES = {
  nda: '01_ Confidentiality Undertaking for Suppliers - Mutual (ISS World Services) (updated 2023-02-15).docx',
  dpa: 'ISS PoC Data Processing Agreement Template (Group Version).docx',
  dpmOverview: 'Country overview DPM1.xlsx',
  supplierAllocation:
    'Stakeholders_ PoC-as-a-Service_geografical & functional allocation .xlsx',
  pocAgreement: 'Agreement on Proof of Concept -blank.docx',
  triParty:
    'Tri-party Agreement on Proof of Concept_Customer_231016.docx',
  contractCover: '2024-05-29 PoC Contract Cover.docx',
  implementationPlan: 'Implementation plan.xlsx',
  milestonePlan: 'Milestone Plan.pptx',
  launchCommunication: 'Proof-of concept launch communication_template.oft',
  evaluationPptx: 'PoC Evaluation_ template.pptx',
  finalReport: 'PoC Final Evaluation Report structure.docx',
  stocktake: 'StocktakeEdit.xlsx',
} as const;

export function templateHref(fileName: string): string {
  return `/templates/${encodeURIComponent(fileName)}`;
}

export function isPlaceholderLink(href: string): boolean {
  return !href || href === '#';
}

export function documentLinkProps(href: string): {
  href: string;
  download?: string;
  target?: '_blank';
  rel?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
} {
  if (isPlaceholderLink(href)) {
    return {
      href: '#',
      onClick: (event) => event.preventDefault(),
    };
  }

  if (href.startsWith('/templates/')) {
    return {
      href,
      download: decodeURIComponent(href.slice('/templates/'.length)),
    };
  }

  return {
    href,
    target: '_blank',
    rel: 'noopener noreferrer',
  };
}
